export default (value) => {
  let fullName = value.name
  if (value.lastname)
    fullName += ' ' + value.lastname
  if (value.lastname2)
    fullName += ' ' + value.lastname2
  return fullName
}


// WEBPACK FOOTER //
// ./src/filters/fullName.js